import { createFeature, createReducer, on } from '@ngrx/store';
import { SoftBanActions } from 'src/app/core/state/slices/soft-ban/soft-ban.actions';
import { SoftBanState } from 'src/app/core/state/slices/soft-ban/soft-ban.model';

const initialState: SoftBanState = {
  loaded: false,
  loading: false,
  hasActiveSoftBan: false,
  modalShownRoutes: [],
};
/**
 * Reducers are pure functions that must always return the new state object and not mutate it.
 */
const softBanReducer = createReducer<SoftBanState>(
  initialState,
  on(SoftBanActions.resetState, () => ({ ...initialState })),
  on(SoftBanActions.getStatus, (state) => ({ ...state, loading: true })),
  on(SoftBanActions.setStatus, (state, { status }) => ({
    ...state,
    loaded: true,
    loading: false,
    hasActiveSoftBan: status,
  })),
  on(SoftBanActions.addModalShownRoute, (state, { route }) => {
    if (state.modalShownRoutes.indexOf(route) === -1) {
      return { ...state, modalShownRoutes: [...state.modalShownRoutes, route] };
    }
    // If state is returned as is it won't trigger selectors to re-calculate values
    // hence observables subscribed to those selectors won't fire.
    return state;
  }),
);

/**
 * Creates feature that can be user as feature slice in StoreModule.forFeature.
 * Also creates feature selector and a select for each feature state property.
 */
export const softBanFeature = createFeature({
  name: 'SoftBanFeature',
  reducer: softBanReducer,
});
